import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getUserRequests } from "../../service/api/UserRequestsService";
import { Solicitud } from "./Solicitud";
import { Link } from "react-router-dom";

const MAX_ITEMS = 3;
const PAGE = 1;

export const UltimasSolicitudes = () => {

    const [solicitudes, setSolicitudes] = useState([]);

    useEffect(() => {
        getUserRequests(PAGE, MAX_ITEMS).then(data => {
            setSolicitudes(data);
        })
    }, [])

    return solicitudes.userGradeRequests != null && solicitudes.userGradeRequests.length > 0 ? (
            <> <div className="container">
            <div className="row text-start cards-header">
                <div className="col-12 col-xl-6 ps-4 pb-3">
                    <h3>Últimas solicitudes de eGrade</h3>
                    <h6>Estos son los últimos eGrade que has solicitado: </h6>
                </div>
                <div className="text-end col-12 ver-todas col-xl-6">
                    <Link to="/request" style={{ textDecoration: 'none', color: '#5c157d' }}>
                        <p>Ver todas</p>
                    </Link>
                </div>
            </div>
        </div>
                {solicitudes.userGradeRequests.map((solicitud) => {
                    return <Solicitud solicitud={solicitud} key={solicitud.requestId} />
                })}
            </>
        ) : null;
}